import PublicContentPage from '@/components/PublicContentPage/PublicContentPage';
import { CONSTANTS } from '@/constants';
import { environmentVariables } from '@/utils/environmentVariables';
import { getEkardoApolloClient } from '@netfront/common-library';
import {
  GET_CONTENT_PAGE_BY_URL_QUERY,
  IContentPage,
  IGetContentPageByUrlQueryGraphQLResponse,
  IGetContentPageByUrlQueryVariables,
} from '@netfront/ekardo-content-library';
import { NextPage, GetStaticProps } from 'next';
import { useRouter } from 'next/router';

const ContentNextPage: NextPage<{ contentPage: IContentPage }> = ({ contentPage }: { contentPage: IContentPage }) => {
  const {
    query: { pageUrl },
  } = useRouter();

  return <PublicContentPage contentPage={contentPage} pageUrl={String(pageUrl)} showHeader={false} />;
};

export const getStaticProps: GetStaticProps = async ({}) => {
  const client = getEkardoApolloClient({
    product: 'EKARDO',
  });

  try {
    const result = await client.query<IGetContentPageByUrlQueryGraphQLResponse, IGetContentPageByUrlQueryVariables>({
      query: GET_CONTENT_PAGE_BY_URL_QUERY,
      variables: {
        contentPageUrl: environmentVariables.homePageCmsUrl,
        projectId: environmentVariables.projectId,
      },
    });

    const contentPage = result.data.contentPage.getContentPageByUrl;

    return {
      props: {
        contentPage,
      },
      revalidate: CONSTANTS.STATIC_PAGE_REGENERATION_TIME_IN_SECONDS,
    };
  } catch (error) {
    console.error('Failed to fetch content page for home page:', error, JSON.stringify(error));
    throw new Error('Failed to fetch content page for home page');
  }
};

export default ContentNextPage;
